import * as React from 'react';
import { Translate } from 'react-redux-i18n';

interface RemainingTimeLabelProps {
	seconds: number;
}

const RemainingTimeLabel = ({ seconds }: RemainingTimeLabelProps) => {
	const DENOMINATOR = 60;

	if (seconds < DENOMINATOR) {
		return <Translate value="messages.less_than_minute_left" />;
	}

	const minutes = Math.ceil(seconds / DENOMINATOR);

	if (minutes < DENOMINATOR) {
		const messageKey = minutes === 1 ? 'one_minute_left' : 'minutes_left';
		return (
			<Translate
				value={`messages.${messageKey}`}
				minutes={minutes.toString()}
			/>
		);
	}

	const hours = Math.ceil(seconds / DENOMINATOR / DENOMINATOR);
	const messageKey = hours === 1 ? 'one_hour_left' : 'hours_left';

	return (
		<Translate
			value={`messages.${messageKey}`}
			hours={hours.toString()}
		/>
	);
};

export default RemainingTimeLabel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ImportDesktopFile/Toast/RemainingTimeLabel/index.tsx